import { Claims, User } from '@keyliving/shared-types';

import { authApi } from '../api/apiModule';

export const authService = authApi.injectEndpoints({
    endpoints: (builder) => ({
        me: builder.query<User, void>({
            query: () => ({
                url: '/users/me',
                method: 'GET',
            }),
            transformResponse: (res: { user: User }) => {
                return res.user;
            },
            providesTags: () => {
                return [{ type: 'User', id: 'me' }];
            },
        }),
        verifyAuthToken: builder.query<Claims, string>({
            query: (token) => ({
                url: '/users/verify',
                method: 'POST',
                body: { token },
            }),
            transformResponse: (res: { claims: Claims }) => {
                return res.claims;
            },
        }),
    }),
});

// auto-generated based on the defined endpoints
export const { useLazyMeQuery, useLazyVerifyAuthTokenQuery, useMeQuery } = authService;
